<template>
    <div :class="`grid grid-cols-${total} w-2/5 align-middle mx-auto items-center`">
        <div class="accreditslinks" v-for="(result, index) in accredits" :key="index">
            <span v-if="result === 'Arbor Day'">
                <NuxtLink to="http://www.arborday.org/">
                    <img loading="lazy" src="~/assets/images/arbor-day-foundation.png" alt="Arbor Day" />
                </NuxtLink>
            </span>

            <span v-else-if="result === 'Project EverGreen'">
                <NuxtLink to="http://projectevergreen.org/">
                    <img loading="lazy" src="~/assets/images/evergreen.png" alt="Project EverGreen" />
                </NuxtLink>
            </span>

            <span v-else-if="result === 'PLANET'">
                <NuxtLink to="https://www.landcarenetwork.org/PLANET">
                    <img loading="lazy" src="~/assets/images/national-association-landscape-professionals.png" alt="National Association Landscape Professionals" />
                </NuxtLink>
            </span>

            <span v-else-if="result === 'Better Business Bureau'">
                <NuxtLink to="https://www.bbb.org/oklahomacity/business-reviews/lawn-maintenance/spring-green-lawn-care-of-edmond-in-edmond-ok-90052660">
                    <img loading="lazy" src="~/assets/images/BBB-logo-small.png" alt="Better Business Bureau" />
                </NuxtLink>
            </span>

            <span v-else-if="result === 'GreenCare For Troops'">
                <NuxtLink to="https://projectevergreen.org/greencare-and-snowcare-for-troops/">
                    <img loading="lazy" src="~/assets/images/greenprogramtransparent.png" alt="GreenCare For Troops" />
                </NuxtLink>
            </span>

            <span v-else-if="result === 'Texas Department of Agriculture'">
                <NuxtLink to="https://www.texasagriculture.gov/">
                    <img loading="lazy" src="~/assets/images/dept-tx-clear-300.png" alt="Texas Department of Agriculture" />
                </NuxtLink>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    total: {
        type: Number,
        default: 3
    },
    accredits: {
        type: Array,
        default: () => []
    }
});
</script>

<style scoped>

</style>
